import classNames from 'classnames';

import { CircleCheckedIcon, CircleIcon } from '../Icons';

export const ContractTypeCheckItem = ({
  title,
  description,
  checked,
  className,
  onClick
}: {
  title: string;
  description: string;
  checked: boolean;
  className?: string;
  onClick: () => void;
}) => {
  return (
    <div
      className={classNames(
        'cursor-pointer px-3 py-4 border-gray-200 border rounded-lg bg flex-1 flex flex-row ' + className,
        {
          'border-primary-600': checked,
          'bg-primary-50': checked
        }
      )}
      onClick={() => onClick()}
    >
      <div>{checked ? <CircleCheckedIcon /> : <CircleIcon />}</div>
      <div className="ml-2">
        <div className="text-sm font-medium text-gray-700">{title}</div>
        <div className="mt-1 text-sm font-normal text-gray-500">{description}</div>
      </div>
    </div>
  );
};
